var Canvas = require('../../canvas/canvas');

require('backboneFwd');

/**
 * Mixed into Page If Canvas Necessary
 * Allows to have page module without Raphael for just rendering images
 * Also, commands pass though the viewer to the page to the canvas; not from the viewer to the canvas -- allowing for multi canvases
 * Note: renders and wires but doesn't put in DOM
 */


module.exports = {

    canvas: null, /* the instance of the canvas */

    pgCanvasChannel: null,

    // note: set upon canvas creation && forwarded directly to canvasPageChannel outer subscriptions/requests ... so to not break ...
    // TODO: combine any that just call re-render into re-render shapes
    viewModesSubs: {
        noteSaved:                  'noteSaved',
        activeNoteChange:           'activeNoteChange',
        expandedNoteChange:         'expandedNoteChange',
        activeNoteSubTypeChange:    'activeNoteSubTypeChange',
        toggleHighlightedNote:      'toggleHighlightedNote',
        noteDeleted:                'noteDeleted',
        setDrawColor:               'setDrawColor',
        setStrokeWidth:             'setStrokeWidth',
        closeCanvasDialogs:          'closeCanvasDialogs',
        repositionShapeDialog:      'repositionShapeDialog', // ( this not forward when the page container is scrolled )
        graphicStampChanged:        'graphicStampChanged',
        consultGroupChange:         'consultGroupChange',
        applyAllRedactionsToggled:  'applyAllRedactionsToggled',
        pageRotated:                'pageRotated',
        reRenderShapes:             'reRenderShapes'
    },


    /* exports -- TODO: just forward events to vChannel ( and I think can rid from here -- just go to subsCallbacks */
    canvasSubs: {
        hoveredNoteChange:          'hoveredNoteChange',
        drawingToggled:             'drawingToggled',
        changeActiveNoteSubtype:    'changeActiveNoteSubtype',
        cancelSignature:            'cancelSignature'
    },

    createAndRenderCanvas: function() {

        this.pgCanvasChannel = new Backbone.Radio.Channel('pgCanvasChannel:' + this.cid);

        this._wireCommunicationWithCanvas();

        // Note: init will create the canvasView but not render the shapes/set the dimensions
        // ( Everything that can be done with it being in the DOM yet )
        // At this point in page loading WF, page view must be in the DOM

        this.canvas = new Canvas({
            vChannel: this.vChannel,
            pageCanvasCh: this.pgCanvasChannel,
            page: this.model,
            scale: this.scale
        });

        // Put the canvas view in the DOM prior to rendering the shapes and setting the bounds
        this.ui.canvasPlaceholder.append( this.canvas.canvasView.el );

        // Post DOM 'render'; no longer a render method on the view.
        // First time through this sets the bounds and renders the shapes
        this.pgCanvasChannel.command( 'reRenderShapes' );

    },

    /* all viewer communication needs to pass through the page object and filter it applies to the page */
    _wireCommunicationWithCanvas: function() {

        Backbone.fwd.call( this.options.viewMdsCh, this.pgCanvasChannel );
        Marionette.bindEntityEvents(this, this.options.viewMdsCh, this.viewModesSubs);   /* FORWARD TO */
        Marionette.bindEntityEvents(this, this.pgCanvasChannel, this.canvasSubs);   /* FORWARD FROM */
    },

    scaleCanvas: function(scale, prevScale, options) {

        var c = this.pgCanvasChannel;
        c.command('updateScale', scale, prevScale, options);

    },


    //  unsure if necessary ....
    // unwireCommunicationWithCanvas: function() {
    //
    //    this.options.viewMdsCh.stopListening(this.pgCanvasChannel);
    //    Marionette.unbindEntityEvents(this, this.options.viewMdsCh, this.viewModesSubs);
    //    Marionette.unbindEntityEvents(this, this.pgCanvasChannel, this.canvasSubs);
    //
    //},

    /* ----- The Forwards ----- */

    // Intermediary steps here desired before forwarding directly from here (page) to the canvas
    // Also this one not a one-one forward -- just call reRenderShapes
    activeNoteChange: function(note, options) {

        var c = this.pgCanvasChannel,
            args = _.toArray(arguments);

        // Take action on the page first
        this.triggerMethod.apply( this, ['activeNoteChange'].concat(args) );

        c.command('reRenderShapes');

    },

    closeCanvasDialogs: function() {
        var c = this.pgCanvasChannel;
        c.command.apply(c, ['closeCanvasDialogs'].concat( _.toArray(arguments)) );
    },
    repositionShapeDialog: function() {
        var c = this.pgCanvasChannel;
        c.command.apply(c, ['repositionShapeDialog'].concat(_.toArray(arguments)));
    },
    toggleHighlightedNote: function() {
        var c = this.canvas; //(this one also trigger from the other side)
        c.toggleHighlightedNote.apply(c, arguments);
    },
    setDrawColor: function() {  //overlap with active note change -- removeNoteShapesFromCanvas old
        var c = this.pgCanvasChannel;
        c.command.apply(c, ['setDrawColor'].concat(_.toArray(arguments)));
    },
    setStrokeWidth: function() {
        var c = this.pgCanvasChannel;
        c.command.apply(c, ['setStrokeWidth'].concat(_.toArray(arguments)));
    },
    noteDeleted: function() {  //overlap with active note change -- removeNoteShapesFromCanvas old
        var c = this.pgCanvasChannel;
        c.command.apply(c, ['noteDeleted'].concat(_.toArray(arguments)));
    },
    noteSaved: function() {
        var c = this.pgCanvasChannel;
        c.command.apply(c, ['noteSaved'].concat(_.toArray(arguments)));
    },
    activeNoteSubTypeChange: function() {
        var c = this.pgCanvasChannel;
        c.command.apply(c, ['activeNoteSubTypeChange'].concat(_.toArray(arguments)));
    },

    expandedNoteChange: function() {
        var c = this.pgCanvasChannel;
        c.command.apply( c, ['expandedNoteChange'].concat(_.toArray(arguments)) );
    },

    graphicStampChanged: function() {
        var c = this.pgCanvasChannel;
        c.command.apply(c, ['graphicStampChanged'].concat( _.toArray(arguments)) );
    },

    consultGroupChange: function() {
        var c = this.pgCanvasChannel;
        c.command.apply(c, ['consultGroupChange'].concat( _.toArray(arguments)) );
    },

    reRenderShapes: function() {
        this.pgCanvasChannel.command('reRenderShapes');
    },

    /* ------ exports -- of vChannel ----- */
    cancelSignature: function() {
        var c = this.vChannel;
        c.trigger.apply(c, ['canvas:cancelSignature'].concat( _.toArray(arguments) ));
    },
    changeActiveNoteSubtype: function() {
        var c = this.vChannel;
        c.trigger.apply(c, ['canvas:changeActiveNoteSubtype'].concat( _.toArray(arguments) ));
    },
    drawingToggled: function() {
        var c = this.vChannel;
        c.trigger.apply(c, ['canvas:drawingToggled'].concat( _.toArray(arguments) ));
    },
    hoveredNoteChange: function() {
        var c = this.vChannel;
        c.trigger.apply(c, ['canvas:hoveredNoteChange'].concat( _.toArray(arguments) ));
    },
    applyAllRedactionsToggled: function() {
        var c = this.pgCanvasChannel;
        c.command.apply(c, ['applyAllRedactionsToggled'].concat( _.toArray(arguments)) );
    },
    pageRotated: function() {
        var c = this.pgCanvasChannel;
        c.command.apply(c, ['pageRotated'].concat( _.toArray(arguments)) );
    }


};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/canvasMixin/canvasMixin.js
 ** module id = 464
 ** module chunks = 0
 **/